module.exports = __webpack_public_path__ + "img/ck65.c125aadc.png";